import React from 'react'
import PathToSaleBaseSkeleton from '@signal/components/PathToSale/Skeleton'
import TimelineViewSkeleton from './../TimelineView/Skeleton'

const PathToSaleSkeleton = () => (
  <PathToSaleBaseSkeleton timelineViewComponent={TimelineViewSkeleton} />
)

export default PathToSaleSkeleton
